import React, { FC } from 'react';
import { TileProps } from '@v2/context/ProductionBatch/types';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { Text, View } from 'react-native';
import { Period } from '@v2/pages/batch/details/modules/batch/components/BatchDetailsBlock/BatchDetailsBlockContent';
import { BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH } from '@v2/context/ProductionBatch/tile/constants';
import { InlineErrorBoundary, InlineErrorFallbackSize } from '@v2/components/errorBoundary';

interface InfoBlockProps extends Pick<TileProps, 'batch' | 'C'>{
  limitWidth?: boolean;
}

const InfoBlock: FC<InfoBlockProps> = ({ batch, C, limitWidth = false }) => {
  const textColor = 'Label/Light/Tertiary';
  const fontType: keyof typeof font = 'Subhead 1';
  const textStyles = [font[fontType], { color: C(textColor) }];

  return (
    <View style={[{ gap: scale(4) }, limitWidth && {width: BATCH_NUMBER_STATUS_LINKED_INFO_BLOCK_WIDTH}]}>
      <InlineErrorBoundary screenName="BatchTileInfoBlock" size={InlineErrorFallbackSize.Micro}>
        <Period
          C={C}
          startedOn={batch.startedOn}
          endedOn={!batch?.isInProgress ? batch?.endedOn : undefined}
          fontType={fontType}
          color="Label/Light/Tertiary"
        />
        <Text style={textStyles}>{batch.machineShortName}</Text>
        <Text numberOfLines={1} style={textStyles}>{batch.ncFileName}</Text>
      </InlineErrorBoundary>
    </View>
  );
};

export default InfoBlock;